import React from 'react';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StackScreenProps } from '@react-navigation/stack';
import { RootStackParamList } from '../navigation/types';
import { useAuthStore } from '../store/useAuthStore';
import { useActivityStore } from '../store/useActivityStore';
import { StrokeSyncService } from '../services/StrokeSyncService';
import { LessonComplete } from '../components/LessonComplete';
import { CopyrightFooter } from '../components/CopyrightFooter';

type Props = StackScreenProps<RootStackParamList, 'LessonComplete'>;

export function LessonCompleteScreen({ navigation }: Props) {
    const { leaveClass, switchStudent, classId } = useAuthStore();
    const { resetActivities, startPendingActivity } = useActivityStore();

    const handleLogout = () => {
        StrokeSyncService.stopSync();
        resetActivities();
        leaveClass();
        navigation.replace('Home');
    };

    const handleStartPending = (activityId?: string) => {
        startPendingActivity(activityId);
        navigation.navigate('ActiveLesson');
    };

    const handleSwitchProfile = () => {
        const serverUrl = StrokeSyncService.getServerUrl();
        StrokeSyncService.stopSync();
        resetActivities();
        switchStudent(); // preserves deviceToken, classId, serverUrl
        if (classId && serverUrl) {
            navigation.replace('RosterPick', { classId, serverUrl });
        } else {
            navigation.replace('Home');
        }
    };

    return (
        <SafeAreaView style={styles.container} accessibilityLabel="Lesson complete screen" accessibilityRole="none">
            <LessonComplete
                onLogout={handleLogout}
                onSwitchProfile={handleSwitchProfile}
                onStartPending={handleStartPending}
            />
            <CopyrightFooter />
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#F8FAFC',
    }
});
